import '../styles/globals.css'
import 'viewerjs/dist/viewer.css'
import type { AppProps } from 'next/app'
import GlobalCtx from '../context/global'
import { useEffect, useState } from 'react'
import { ICar, IError, IGalleryImage, IGarage } from 'shared-interfaces'
import * as Sentry from '@sentry/nextjs'
import { useRouter } from 'next/router'
import posthog from 'posthog-js'

function App({ Component, pageProps }: AppProps) {
    const [garage, setGarage] = useState<IGarage | null>(null)
    const [car, setCar] = useState<ICar | null>(null)
    const [currentImage, setCurrentImage] = useState<IGalleryImage | null>(null)
    const [
        isMobileNavigationBottomSheetOpen,
        toggleMobileNavigationBottomSheet,
    ] = useState(false)
    const [isPlatformMenuOpen, togglePlatformMenu] = useState(false)
    const [error, setError] = useState<IError | null>(null)

    const router = useRouter()

    // const { publicRuntimeConfig } = getConfig()

    // const env: any = publicRuntimeConfig.APP_ENV

    // let pg_key =
    //     env === 'production'
    //         ? 'phc_MRTan0QxFBHW1ULk72hUg3pcuZaGbG6oLCkTjqadV6h'
    //         : 'phc_MRTan0QxFBHW1ULk72hUg3pcuZaGbG6oLCkTjqadV6h-aVgRX01aK_Xn9UeQTZeVBw8ayCk'

    useEffect(() => {
        if (router.isReady) {
            let phKey =
                process.env.APP_ENV === 'development'
                    ? 'lrRCQAXwXPAhZua-aVgRX01aK_Xn9UeQTZeVBw8ayCk'
                    : 'phc_MRTan0QxFBHW1ULk72hUg3pcuZaGbG6oLCkTjqadV6h'
            // Init PostHog
            posthog.init(phKey, {
                api_host: 'https://app.posthog.com',
                loaded: (posthog) => {
                    if (
                        process.env.APP_ENV === 'local' ||
                        process.env.APP_ENV === 'development'
                    ) {
                        posthog.opt_out_capturing()
                    }
                },
            })

            // Track page views
            const handleRouteChange = () => posthog.capture('$pageview')
            router.events.on('routeChangeComplete', handleRouteChange)
        }

        const onRouteChangeComplete = () => {
            // Track page views
            const handleRouteChange = () => posthog.capture('$pageview')
            router.events.on('routeChangeComplete', handleRouteChange)
        }
        router.events.on('routeChangeComplete', onRouteChangeComplete)
        return () => {
            router.events.off('routeChangeComplete', onRouteChangeComplete)
        }
    }, [router])

    return (
        <Sentry.ErrorBoundary fallback={undefined}>
            <GlobalCtx.Provider
                value={{
                    garage,
                    setGarage,
                    car,
                    setCar,
                    currentImage,
                    setCurrentImage,
                    isMobileNavigationBottomSheetOpen,
                    toggleMobileNavigationBottomSheet,
                    isPlatformMenuOpen,
                    togglePlatformMenu,
                    error,
                    setError,
                }}
            >
                <Component {...pageProps} />
            </GlobalCtx.Provider>
        </Sentry.ErrorBoundary>
    )
}

export default App
